import { supabase } from '../../../shared/lib/supabase';

// Define the Season interface based on your schema
export interface Season {
  id: string;
  name: string;
  start_date: string;
  end_date: string;
  created_at: string;
  updated_at: string;
  active: boolean;
  data_source: string;
}

export interface SeasonCreateInput {
  name: string;
  start_date: string;
  end_date: string;
  active?: boolean;
  data_source: string;
}

export interface SeasonUpdateInput {
  name?: string;
  start_date?: string;
  end_date?: string;
  active?: boolean;
  data_source?: string;
}

class SeasonsService {
  async getAll(): Promise<Season[]> {
    try {
      console.log('🔍 Fetching seasons...');
      const { data, error } = await supabase
        .from('seasons')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching seasons:', error);
        throw error;
      }

      console.log('✅ Seasons fetched successfully:', data?.length || 0);
      return data || [];
    } catch (error) {
      console.error('Error in seasonsService.getAll:', error);
      throw error;
    }
  }

  async getById(id: string): Promise<Season | null> {
    try {
      const { data, error } = await supabase
        .from('seasons')
        .select('*')
        .eq('id', id)
        .single();

      if (error) {
        console.error('Error fetching season:', error);
        throw error;
      }

      return data;
    } catch (error) {
      console.error('Error in seasonsService.getById:', error);
      throw error;
    }
  }

  async create(season: SeasonCreateInput): Promise<Season> {
    try {
      console.log('🔍 Creating season:', season);
      const { data, error } = await supabase
        .from('seasons')
        .insert([season])
        .select()
        .single();

      if (error) {
        console.error('Error creating season:', error);
        throw error;
      }

      console.log('✅ Season created successfully:', data);
      return data;
    } catch (error) {
      console.error('Error in seasonsService.create:', error);
      throw error;
    }
  }

  async update(id: string, season: SeasonUpdateInput): Promise<Season> {
    try {
      console.log('🔍 Updating season:', id, season);
      const { data, error } = await supabase
        .from('seasons')
        .update(season)
        .eq('id', id)
        .select()
        .single();

      if (error) {
        console.error('Error updating season:', error);
        throw error;
      }

      console.log('✅ Season updated successfully:', data);
      return data;
    } catch (error) {
      console.error('Error in seasonsService.update:', error);
      throw error;
    }
  }

  async delete(id: string): Promise<void> {
    try {
      console.log('🔍 Deleting season:', id);
      const { error } = await supabase
        .from('seasons')
        .delete()
        .eq('id', id);

      if (error) {
        console.error('Error deleting season:', error);
        throw error;
      }

      console.log('✅ Season deleted successfully');
    } catch (error) {
      console.error('Error in seasonsService.delete:', error);
      throw error;
    }
  }
}

export const seasonsService = new SeasonsService();
